import React from "react";
import svg89 from "../../../assets/svg/svg89.svg";

function OurStory() {
  return (
    <div className="lg:py-[5rem] py-[2rem] lg:px-0 px-3  justify-center items-center  flex lg:flex-row flex-col-reverse bg-white gap-[2.94rem]">
      <img src={svg89} alt="svg89" className="object-contain rounded-[12px]" />
      <div className="flex flex-col gap-[1.5rem]">
        <span className="text-[#000] text-[2.875rem] font-[600] leading-[3.375rem]">
         About Us
        </span>
        <span className="text-[#4F4770] text-[1rem] font-[400] leading-[1.625rem] lg:max-w-[33.38938rem] w-full">
          Ndovu Pay was founded with one clear mission, to make business
          payments in Africa simple and reliable. We noticed how organizations
          struggled with manual payrolls, delayed disbursements, and poor
          visibility over expenses. So we built a platform where you can pay,
          track, and reconcile all transactions from a single place.
        </span>
      </div>
    </div>
  );
}

export default OurStory;
